import React from "react";
import { formatToLocalTime } from "../services/weatherService";

function TimeAndLocation({ weather: { dt, timezone, name, country } }) {
  return (
    <div >
      <div className="flex items-center justify-center my-1 sm:flex sm:items-center sm:justify-center sm:my-6 md:flex md:items-center md:justify-center md:my-6 lg:flex lg:items-center lg:justify-center lg:my-6">
        <p className="text-white text-sm font-light sm:text-xl md:text-xl lg:text-xl">
          {formatToLocalTime(dt, timezone)}
        </p>
      </div>

      <div className="flex items-center justify-center my-3">
        <p className="text-white text-2xl font-medium sm:text-3xl md:text-3xl lg:text-3xl">{`${name}, ${country}`}</p>
      </div>
    </div>
  );
}

export default TimeAndLocation;